export const APP_CONFIG = {
  // BASE_URL: "http://localhost:8001/",
  // BASE_URL: "https://api.omayoza.com/",
  BASE_URL: "https://orca-app-nfkty.ondigitalocean.app/",
  COINBASE_API_KEY: "c3d44e22-6249-485a-9a78-005be8111c3d",
};
